export const color2 = 'lightgreen';
export const color3 = 'pink';
export const color5 = '#DFDCE3';
export const color6 = 'deeppink';
